"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setMailboxRegionalConfigurationOperation_1 = require("owa-service/lib/operation/setMailboxRegionalConfigurationOperation");
var setMailboxRegionalConfigurationData_1 = require("owa-service/lib/factory/setMailboxRegionalConfigurationData");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function setMailboxRegionalConfiguration(locale, renameDefaultFolders, dateFormat, timeFormat, timeZone) {
    return setMailboxRegionalConfigurationOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: setMailboxRegionalConfigurationData_1.default({
            Language: locale,
            LocalizeDefaultFolderName: renameDefaultFolders,
            DateFormat: dateFormat,
            TimeFormat: timeFormat,
            TimeZone: timeZone,
        }),
        SkipUserCultureCookies: false,
    });
}
exports.default = setMailboxRegionalConfiguration;
//# sourceMappingURL=setMailboxRegionalConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/services/setMailboxRegionalConfiguration.js
// module id = 4948
// module chunks = 2